(function () {
  'use strict';

  angular.module('eventBus', []).factory("eventBus", eventBusFactory);

  /** @ngInject */
  function eventBusFactory($rootScope) {
    var eventBus = {};

    eventBus.emitEvent = function (eventName, data) {
      data = data || {};
      $rootScope.$emit(eventName, data);
    };

    eventBus.onEvent = function (eventName, func, scope) {
      var unbind = $rootScope.$on(eventName, func);
      if (scope) {
        scope.$on('$destroy', unbind);
      }
      return unbind;
    };

    eventBus.topics = Object.freeze({
      RELOAD_POINT: 'reloadPoint',
      RELOAD_POINTS: 'reloadPoints',
      WEB_SOCKET_OPEN: 'webSocketOpen',
      WEB_SOCKET_CLOSED: 'webSocketClosed'
    });

    return eventBus;
  }
})();
